import { useEffect } from "react";
import { useSelector } from "react-redux";
import { Modal, Textarea, Button, Group, Title, Rating, Stack, Text, ActionIcon } from "@mantine/core";
import { useForm } from "@mantine/form";
import { IconTrash } from "@tabler/icons-react";

const ModalAssessment = ({ opened, onClose, onSave, onDelete, assessmentData = {} }) => {
  const { saving, deleting, error } = useSelector((state) => state.evaluation.assessments)
  const { carrera, sede, evidenciasValoradas, assessment } = assessmentData ?? null;

  const form = useForm({
    initialValues: {
      puntuacion: assessment ? assessment.puntuacion : 0,
      comentarios: assessment ? assessment.comentarios : ""
    },
    validate: {
      puntuacion: (value) => (value > 0 ? null : "Seleccione una valoración")
    }
  });

  useEffect(() => {
    if (assessment) {
      form.setValues({
        puntuacion: assessment.puntuacion,
        comentarios: assessment.comentarios
      });
    }
  }, [assessment]);

  useEffect(() => {
    if (!opened) {
      form.reset(); // Reiniciar el formulario cuando el modal se cierra
    }
  }, [opened]);

  const handleSubmit = () => {
    const validation = form.validate();
    if (!validation.hasErrors) {
      const nuevoRecurso = {
        codigoCarrera: carrera?.codigo,
        codigoSede: sede,
        puntuacion: form.values.puntuacion,
        comentarios: form.values.comentarios,
        evidencias: evidenciasValoradas
      };

      if (assessment?.Id) {
        nuevoRecurso.Id = assessment.Id; 
      }

      onSave(nuevoRecurso);
    }
  };

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title={<Text fw={500} size="md">{carrera?.descripcion} - {sede}</Text>}
      centered
      size="450px"
      closeOnClickOutside={false}
    >
      <Stack align="stretch" justify="center" gap="xs">
        <Text>A continuación, indique el nivel de cumplimiento alcanzado</Text>
        <Group justify="center">
          <Rating 
            size={45} 
            count={4}
            disabled={saving || deleting}
            {...form.getInputProps("puntuacion")}
          />
        </Group>
        <Textarea
          label="Comentarios"
          mt="md"
          disabled={saving || deleting}
          {...form.getInputProps("comentarios")}
        />
        <Group wrap="nowrap" spacing="xs" mt="md" >
          {assessment?.Id && (
            <ActionIcon 
              onClick={() => onDelete(assessment.Id)}
              loading={deleting}
              disabled={saving}
              color="grey"
              size="input-sm"
            >
              <IconTrash/>
            </ActionIcon>  
          )}
          <Button 
            fullWidth 
            color="#e91e63" 
            onClick={handleSubmit}
            loading={saving}
            disabled={deleting}
          >
            Guardar Valoración
          </Button>
        </Group>
      </Stack>
    </Modal>
  );
};

export default ModalAssessment;
